import React, { useState } from 'react';
import {
  FaPhone,
  FaStar,
  FaHeart,
  FaShoppingCart,
  FaEye,
  FaFilter,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaArrowRight,
  FaRegHeart,
  FaCheck,
  FaTruck,
  FaShieldAlt,
  FaUndo,
  FaMale,
  FaFemale,
  FaWeight,
  FaGlobe,
  FaTag,
  FaRuler,
  FaBox,
  FaSearch,
  FaCheckCircle,
  FaQuestionCircle,
  FaCamera,
  FaUser,
  FaStarHalfAlt,
  FaGift,
  FaPercentage,
  FaRupeeSign,
  FaExchangeAlt,
  FaStore,
  FaCube,
  FaRegEye,
  FaCreditCard
} from 'react-icons/fa';

const ProductListing = () => {
  const [selectedFilters, setSelectedFilters] = useState({
    frameType: [],
    frameShape: [],
    frameColor: [],
    frameSize: [],
    price: { min: 0, max: 5000 },
    gender: [],
    material: [],
    weightGroup: [],
    subCollection: [],
    frameWidth: [],
    countryOfOrigin: [],
    productType: []
  });

  const [expandedSections, setExpandedSections] = useState({
    frameType: true,
    frameShape: true,
    frameColor: true,
    frameSize: false,
    price: false,
    gender: false,
    material: false,
    weightGroup: false,
    subCollection: false,
    frameWidth: false,
    countryOfOrigin: false,
    productType: false
  });

  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [sortBy, setSortBy] = useState('Best Sellers');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState('Medium');
  const [selectedColor, setSelectedColor] = useState('Black');
  const [quantity, setQuantity] = useState(1);
  const [priceRange, setPriceRange] = useState({ min: 0, max: 5000 });
  const [searchTerm, setSearchTerm] = useState('');
  const [activeImage, setActiveImage] = useState(0);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [showFullReviews, setShowFullReviews] = useState(false);
  const [pincode, setPincode] = useState('');
  const [deliveryChecked, setDeliveryChecked] = useState(false);

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleFilterChange = (category, value) => {
    setSelectedFilters(prev => {
      const current = prev[category];
      if (Array.isArray(current)) {
        if (current.includes(value)) {
          return { ...prev, [category]: current.filter(item => item !== value) };
        } else {
          return { ...prev, [category]: [...current, value] };
        }
      }
      return prev;
    });
  };

  const handlePriceChange = (type, value) => {
    setPriceRange(prev => ({
      ...prev,
      [type]: value
    }));
    setSelectedFilters(prev => ({
      ...prev,
      price: { ...prev.price, [type]: value }
    }));
  };

  const toggleWishlist = (productId, e) => {
    e.stopPropagation(); 
    if (wishlist.includes(productId)) {
      setWishlist(wishlist.filter(id => id !== productId));
    } else {
      setWishlist([...wishlist, productId]);
    }
  };

  const openProductDetail = (product) => {
    setSelectedProduct(product);
    document.body.style.overflow = 'hidden';
  };

  const closeProductDetail = () => {
    setSelectedProduct(null);
    document.body.style.overflow = 'unset';
  };

  const clearAllFilters = () => {
    setSelectedFilters({
      frameType: [],
      frameShape: [],
      frameColor: [],
      frameSize: [],
      price: { min: 0, max: 5000 },
      gender: [],
      material: [],
      weightGroup: [],
      subCollection: [],
      frameWidth: [],
      countryOfOrigin: [],
      productType: []
    });
    setPriceRange({ min: 0, max: 5000 });
  };

  const getActiveFilterCount = () => {
    let count = 0;
    Object.entries(selectedFilters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        count += value.length;
      }
    });
    return count;
  };

  const checkDelivery = () => {
    if (pincode.length === 6) {
      setDeliveryChecked(true);
    }
  };

  const frameShapes = ['Square', 'Round', 'Rectangle', 'Geometric', 'Aviator', 'Cat Eye'];
  const frameColors = [
    { name: 'Black', count: 80, hex: '#000000' },
    { name: 'Transparent', count: 52, hex: '#FFFFFF' },
    { name: 'Blue', count: 38, hex: '#0000FF' },
    { name: 'Silver', count: 30, hex: '#C0C0C0' },
    { name: 'Gold', count: 21, hex: '#FFD700' },
    { name: 'Gunmetal', count: 19, hex: '#2C3539' },
    { name: 'Green', count: 15, hex: '#00FF00' },
    { name: 'Brown', count: 12, hex: '#8B4513' },
    { name: 'White', count: 6, hex: '#FFFFFF' },
    { name: 'Red', count: 4, hex: '#FF0000' },
    { name: 'Purple', count: 4, hex: '#800080' },
    { name: 'Grey', count: 2, hex: '#808080' },
    { name: 'Pink', count: 2, hex: '#FFC0CB' },
    { name: 'Yellow', count: 2, hex: '#FFFF00' }
  ];
  const frameSizes = [
    { name: 'Narrow', count: 45, range: '115-125mm' },
    { name: 'Medium', count: 120, range: '125-135mm' },
    { name: 'Wide', count: 85, range: '135-145mm' },
    { name: 'Extra Wide', count: 56, range: '145-155mm' }
  ];
  const genders = [
    { name: 'Men', count: 156, icon: <FaMale /> },
    { name: 'Women', count: 142, icon: <FaFemale /> },
    { name: 'Unisex', count: 58, icon: <FaTag /> }
  ];
  const materials = [
    { name: 'Acetate', count: 98 },
    { name: 'Metal', count: 76 },
    { name: 'Stainless Steel', count: 45 },
    { name: 'Titanium', count: 32 },
    { name: 'TR90', count: 28 },
    { name: 'Aluminum', count: 15 }
  ];
  const weightGroups = [
    { name: 'Ultra Light', count: 67, range: '<15g' },
    { name: 'Light', count: 89, range: '15-20g' },
    { name: 'Medium', count: 112, range: '20-25g' },
    { name: 'Heavy', count: 34, range: '>25g' }
  ];
  const subCollections = [
    { name: 'BLU', count: 45 },
    { name: 'Hustlr', count: 78 },
    { name: 'Vincent Chase', count: 56 },
    { name: 'John Jacobs', count: 43 },
    { name: 'Aqualens', count: 34 },
    { name: 'LK Air', count: 23 }
  ];
  const frameWidths = [
    { name: 'Small', range: '<125mm', count: 34 },
    { name: 'Medium', range: '125-135mm', count: 98 },
    { name: 'Large', range: '135-145mm', count: 76 },
    { name: 'Extra Large', range: '>145mm', count: 45 }
  ];
  const countries = [
    { name: 'BRframes, opposite west gate of police station, Bhabua Bihar 821101', count: 156 },
  ];
  const productTypes = [
    { name: 'Computer Glasses', count: 156 },
    { name: 'Reading Glasses', count: 98 },
    { name: 'Sunglasses', count: 145 },
    { name: 'Contact Lenses', count: 67 },
    { name: 'Sports Glasses', count: 34 },
    { name: 'Kids Glasses', count: 56 }
  ];

  const products = Array(24).fill({
    name: 'BRframes Premium Computer Glasses',
    rating: 4.8,
    reviews: 8028,
    size: 'Medium',
    price: 700,
    originalPrice: 2000,
    discount: 75,
    image: 'https://img.freepik.com/premium-photo/black-frame-eyeglasses-unisex-isolated-white-background_727279-100.jpg?w=200',
    badge: 'Best Seller',
    description: 'Premium computer glasses with blue cut technology. Reduces eye strain and protects from harmful blue light.',
    inStock: true,
    sizes: ['Narrow', 'Medium', 'Wide', 'Extra Wide'],
    colors: ['Black', 'Blue', 'Silver', 'Gold'],
    gender: 'Unisex',
    material: 'Acetate',
    weight: 'Light',
    collection: 'Premium',
    width: 'Medium',
    origin: 'BRframes, opposite west gate of police station, Bhabua Bihar 821101',
    type: 'Computer Glasses',
    highlights: ['Blue cut', 'Anti-glare', 'Lightweight', 'Durable'],
    deliveryInfo: 'Free shipping • 2 year warranty • 30 days return'
  }).map((product, index) => ({
    ...product,
    id: index,
    reviews: [8028, 864, 2168, 5522, 1469, 1828, 1119, 1355, 1270, 1301][index % 10],
    size: ['Medium', 'Wide', 'Extra Wide', 'Narrow'][index % 4],
    color: index % 3 === 0 ? 'Amethyst' : '',
    badge: index % 5 === 0 ? 'Best Seller' : index % 7 === 0 ? 'New' : '',
    power: index % 4 === 0 ? 'Zero Power' : '',
    plus: index % 3 === 0 ? '+28' : index % 5 === 0 ? '+6' : index % 4 === 0 ? '+4' : ''
  }));

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const similarProducts = products.slice(0, 4).map(p => ({ ...p, id: p.id + 1000 }));
  const reviewStats = { 5: 87, 4: 11, 3: 2, 2: 0, 1: 0 };
  const userReviews = [
    { name: 'Alekhya K.', date: '25 Feb 2026', rating: 5, comment: 'I just loved 🤩 it', likes: 12, image: null },
    { name: 'Amal M.', date: '24 Feb 2026', rating: 5, comment: 'Very nice', likes: 8, image: null },
    { name: 'Hemavathy M.', date: '22 Feb 2026', rating: 5, comment: 'look and frame excellent', likes: 5, image: null },
    { name: 'Deblina R.', date: '21 Feb 2026', rating: 4, comment: 'The frame is really a statement piece...', likes: 3, image: null },
    { name: 'Manisha P.', date: '21 Feb 2026', rating: 5, comment: 'The lens and the frame is good', likes: 7, image: null },
  ];
  const faqs = [
    { q: 'What is the return policy?', a: '30-day hassle-free returns. Frame must be unused.' },
    { q: 'Do I need a prescription?', a: 'For powered lenses, yes. You can upload later.' },
    { q: 'How to clean these glasses?', a: 'Use microfiber cloth and lens cleaner.' },
  ];
  const offers = [
    '10% off on first order: NEW10',
    'No cost EMI on credit cards',
    'Free shipping on orders above ₹999'
  ];
  const warranty = '1 year manufacturer warranty';

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-orange-50">
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <div className="bg-white/20 p-1.5 rounded-full animate-pulse">
              <FaPhone className="text-white text-xs" />
            </div>
            <p className="text-xs font-medium text-orange-100">Problem in placing order?</p>
          </div>
          <a
            href="tel:9709799555"
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-full text-xs font-bold hover:bg-gray-800 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <FaPhone className="text-[10px]" />
            <span>Give a missed call</span>
            <span className="font-extrabold">9709799555</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
        <div className="mb-6">
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-800">Computer Glasses</h1>
          <p className="text-sm text-gray-500 mt-1">Protect your eyes from digital strain</p>
        </div>
        <div className="lg:hidden mb-4">
          <button
            onClick={() => setMobileFilterOpen(true)}
            className="w-full flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-3 shadow-sm"
          >
            <div className="flex items-center gap-2">
              <FaFilter className="text-orange-500 text-sm" />
              <span className="font-medium text-gray-800">Filter & Sort</span>
              {getActiveFilterCount() > 0 && (
                <span className="bg-orange-500 text-white text-xs px-2 py-0.5 rounded-full">
                  {getActiveFilterCount()}
                </span>
              )}
            </div>
            <span className="text-xs text-gray-500">356 Results</span>
          </button>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="hidden lg:block w-72 flex-shrink-0">
            <div className="bg-white rounded-xl shadow-lg border border-gray-200 sticky top-4 max-h-[calc(100vh-100px)] overflow-y-auto">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center sticky top-0 bg-white z-10">
                <div>
                  <h3 className="font-bold text-gray-800 flex items-center gap-2">
                    <FaFilter className="text-orange-500 text-sm" />
                    Filters
                  </h3>
                  <p className="text-xs text-gray-500 mt-1">356 Results</p>
                </div>
                <button
                  onClick={clearAllFilters}
                  className="text-xs text-orange-500 hover:text-orange-600 font-medium flex items-center gap-1"
                >
                  <FaTimes className="text-[8px]" />
                  Clear All
                </button>
              </div>
              <div className="p-4 border-b border-gray-200">
                <button onClick={() => toggleSection('frameType')} className="w-full flex items-center justify-between text-left group">
                  <span className="font-semibold text-sm text-gray-700 flex items-center gap-2">
                    <div className="w-5 h-5 bg-orange-100 rounded flex items-center justify-center">
                      <FaTag className="text-orange-500 text-xs" />
                    </div>
                    FRAME TYPE
                  </span>
                  <div className="text-gray-400 group-hover:text-orange-500 transition-colors">
                    {expandedSections.frameType ? <FaChevronUp className="text-xs" /> : <FaChevronDown className="text-xs" />}
                  </div>
                </button>
                {expandedSections.frameType && (
                  <div className="mt-3 space-y-2 pl-7">
                    {['Full Rim', 'Half Rim', 'Rimless'].map((type) => (
                      <label key={type} className="flex items-center justify-between cursor-pointer group">
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            checked={selectedFilters.frameType.includes(type)}
                            onChange={() => handleFilterChange('frameType', type)}
                            className="w-4 h-4 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                          />
                          <span className="text-sm text-gray-600 group-hover:text-orange-500 transition-colors">{type}</span>
                        </div>
                        <span className="text-xs text-gray-400">({Math.floor(Math.random() * 50) + 10})</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex-1">
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-3 mb-4 flex flex-col sm:flex-row flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-2 w-full sm:w-auto">
                <span className="text-xs text-gray-500">Sort By:</span>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="text-sm font-medium bg-transparent text-gray-700 border-none focus:ring-0"
                >
                  <option>Best Sellers</option>
                  <option>Price: Low to High</option>
                  <option>Price: High to Low</option>
                  <option>New Arrivals</option>
                  <option>Rating</option>
                </select>
              </div>
              <div className="relative w-full sm:w-auto">
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full sm:w-48 px-3 py-1.5 pl-8 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500"
                />
                <FaSearch className="absolute left-2.5 top-2 text-gray-400 text-xs" />
              </div>
              <p className="text-xs text-gray-500 w-full sm:w-auto text-center sm:text-right">Showing {filteredProducts.length} of 356 Results</p>
            </div>
            {getActiveFilterCount() > 0 && (
              <div className="flex flex-wrap gap-2 mb-4">
                {Object.entries(selectedFilters).map(([key, value]) => {
                  if (Array.isArray(value) && value.length > 0) {
                    return value.map(item => (
                      <span key={item} className="inline-flex items-center gap-1 bg-orange-100 text-orange-600 text-xs px-2 py-1 rounded-full border border-orange-200">
                        {item}
                        <button onClick={() => handleFilterChange(key, item)} className="hover:text-orange-800">
                          <FaTimes className="text-[8px]" />
                        </button>
                      </span>
                    ));
                  }
                  return null;
                })}
                <button
                  onClick={clearAllFilters}
                  className="text-xs text-gray-500 hover:text-orange-500 transition-colors"
                >
                  Clear all
                </button>
              </div>
            )}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-4">
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  onClick={() => openProductDetail(product)}
                  className="group relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-1 border border-gray-200 hover:border-orange-500 cursor-pointer"
                >
                  {product.badge && (
                    <div className="absolute top-2 left-2 z-10 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-[10px] px-2 py-0.5 rounded-full shadow-lg">
                      {product.badge}
                    </div>
                  )}
                  <button
                    onClick={(e) => toggleWishlist(product.id, e)}
                    className="absolute top-2 right-2 z-10 w-7 h-7 bg-white rounded-full shadow-md flex items-center justify-center hover:scale-110 transition-transform duration-300"
                  >
                    {wishlist.includes(product.id) ? (
                      <FaHeart className="text-red-500 text-sm" />
                    ) : (
                      <FaRegHeart className="text-gray-400 text-sm" />
                    )}
                  </button>
                  <div className="relative h-32 sm:h-40 overflow-hidden bg-gradient-to-br from-orange-50 to-white">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-contain p-3 group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-3">
                    <div className="flex items-center gap-1 mb-1">
                      <div className="flex items-center gap-0.5">
                        <FaStar className="text-yellow-400 text-xs" />
                        <span className="text-xs font-bold text-gray-800">{product.rating}</span>
                      </div>
                      <span className="text-[10px] text-gray-500">({product.reviews})</span>
                    </div>
                    <h3 className="text-xs font-semibold text-gray-800 mb-1 line-clamp-2">
                      {product.name}
                    </h3>
                    <p className="text-[10px] text-gray-500 mb-2">
                      Size: {product.size} • {product.color}
                      {product.power && ` • ${product.power}`}
                    </p>

                    <div className="flex items-center gap-1 mb-2 flex-wrap">
                      <span className="text-base font-bold text-gray-900">₹{product.price}</span>
                      <span className="text-xs text-gray-400 line-through">₹{product.originalPrice}</span>
                      <span className="text-[10px] text-orange-600 font-semibold">({product.discount}% OFF)</span>
                    </div>

                    {product.plus && (
                      <div className="text-[10px] text-orange-500 font-semibold mb-2">
                        {product.plus}
                      </div>
                    )}

                    <button className="w-full bg-orange-500 text-white py-1.5 rounded-lg text-xs font-semibold hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 opacity-0 group-hover:opacity-100 flex items-center justify-center gap-1">
                      <FaShoppingCart className="text-[10px]" />
                      Add to Cart
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-8">
              <button className="bg-white border-2 border-orange-500 text-orange-500 px-8 py-2 rounded-full text-sm font-semibold hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-xl">
                Load More Products
              </button>
            </div>
          </div>
        </div>
        <div className="mt-12">
          <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
            <FaStar className="text-orange-500" />
            Similar Products
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {products.slice(0, 5).map((product) => (
              <a
                key={`similar-${product.id}`}
                href="#"
                className="group bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 hover:border-orange-500"
              >
                <div className="h-20 bg-gray-50 p-2">
                  <img src={product.image} alt="" className="w-full h-full object-contain" />
                </div>
                <div className="p-2">
                  <p className="text-[10px] font-semibold text-gray-800 truncate">{product.name}</p>
                  <p className="text-xs font-bold text-orange-500">₹{product.price}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
      {selectedProduct && (
        <div
          className="fixed inset-0 z-50 bg-white overflow-y-auto"
          onClick={closeProductDetail}
        >
          <div className="sticky top-0 bg-white/80 backdrop-blur-md border-b border-gray-200 z-10 px-4 py-3 flex items-center justify-between">
            <button
              onClick={closeProductDetail}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
            >
              <FaTimes size={18} />
            </button>
            <h2 className="font-semibold text-gray-800 text-base truncate max-w-[200px] md:hidden">{selectedProduct.name}</h2>
            <div className="w-9 h-9" />
            <button
              onClick={(e) => { e.stopPropagation(); toggleWishlist(selectedProduct.id, e); }}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 transition md:hidden"
            >
              {wishlist.includes(selectedProduct.id) ? <FaHeart className="text-red-500" size={18} /> : <FaRegHeart size={18} />}
            </button>
          </div>

          <div className="px-4 md:px-6 lg:px-8 pb-24 md:pb-8" onClick={(e) => e.stopPropagation()}>
            <div className="md:grid md:grid-cols-2 md:gap-8 md:max-w-6xl md:mx-auto">
              <div className="md:sticky md:top-20 md:self-start">
                <div className="py-4 md:py-0">
                  <div className="relative bg-gradient-to-br from-orange-50 to-white rounded-xl flex justify-center">
                    <img
                      src={selectedProduct.images?.[activeImage] || selectedProduct.image}
                      alt={selectedProduct.name}
                      className="w-full max-h-64 md:max-h-96 object-contain"
                    />
                    {selectedProduct.badge && (
                      <span className="absolute top-2 right-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-xs px-3 py-1 rounded-full shadow">
                        {selectedProduct.badge}
                      </span>
                    )}
                  </div>
                  {selectedProduct.images && selectedProduct.images.length > 1 && (
                    <div className="flex gap-2 mt-3 overflow-x-auto py-2">
                      {selectedProduct.images.map((img, idx) => (
                        <button
                          key={idx}
                          onClick={() => setActiveImage(idx)}
                          className={`flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-lg border-2 overflow-hidden transition ${
                            activeImage === idx ? 'border-orange-500' : 'border-gray-200 opacity-70'
                          }`}
                        >
                          <img src={img} alt={`thumb-${idx}`} className="w-full h-full object-cover" />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="py-4 md:py-0">
                <div className="hidden md:block mb-4">
                  <h1 className="text-2xl font-bold text-gray-800">{selectedProduct.name}</h1>
                  <p className="text-gray-500 text-sm mt-1">{selectedProduct.description}</p>
                  <div className="flex items-center gap-3 mt-3">
                    <div className="flex items-center bg-green-600 text-white px-2 py-0.5 rounded text-sm font-semibold">
                      {selectedProduct.rating} <FaStar className="ml-1 text-xs" />
                    </div>
                    <span className="text-gray-600 text-sm">{selectedProduct.reviews} Reviews</span>
                    <span className="text-gray-300">|</span>
                    <span className="text-gray-600 text-sm">{selectedProduct.reviews} sold</span>
                  </div>
                </div>
                <div className="md:hidden mb-3">
                  <h1 className="text-xl font-bold text-gray-800">{selectedProduct.name}</h1>
                  <p className="text-gray-500 text-xs mt-0.5">{selectedProduct.description}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <div className="flex items-center bg-green-600 text-white px-1.5 py-0.5 rounded text-xs font-semibold">
                      {selectedProduct.rating} <FaStar className="ml-1 text-[10px]" />
                    </div>
                    <span className="text-gray-600 text-xs">{selectedProduct.reviews} Reviews</span>
                    <span className="text-gray-300 text-xs">|</span>
                    <span className="text-gray-600 text-xs">{selectedProduct.reviews} sold</span>
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <div className="flex items-baseline gap-2">
                    <span className="text-2xl md:text-3xl font-bold text-gray-900">₹{selectedProduct.price}</span>
                    <span className="text-gray-400 line-through text-xs md:text-sm">₹{selectedProduct.originalPrice}</span>
                    <span className="bg-orange-100 text-orange-600 text-[10px] md:text-xs font-semibold px-2 py-0.5 rounded-full">{selectedProduct.discount}% OFF</span>
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <div className="flex flex-wrap justify-center sm:justify-start gap-3">
                    <button className="bg-orange-500 text-white px-5 py-2.5 rounded-lg font-semibold flex items-center justify-center gap-2 text-sm hover:bg-orange-600 transition">
                      <FaShoppingCart size={14} /> ADD TO CART
                    </button>
                    <button className="bg-black text-white px-5 py-2.5 rounded-lg font-semibold flex items-center justify-center gap-2 text-sm border border-orange-500 hover:bg-gray-900 transition">
                      <FaCreditCard size={14} /> BUY NOW
                    </button>
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaGift className="text-orange-500" size={16} /> Offers</h3>
                  <div className="space-y-1.5">
                    {offers.map((offer, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-xs md:text-sm">
                        <FaPercentage className="text-green-500 flex-shrink-0" size={12} />
                        <span className="text-gray-700">{offer}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <div className="grid grid-cols-3 gap-2">
                    <button className="flex flex-col items-center justify-center bg-orange-50 p-2 md:p-3 rounded-lg text-xs text-gray-700 hover:bg-orange-100 transition">
                      <FaStore className="text-orange-500 text-lg md:text-xl mb-1" />
                      Stores
                    </button>
                    <button className="flex flex-col items-center justify-center bg-orange-50 p-2 md:p-3 rounded-lg text-xs text-gray-700 hover:bg-orange-100 transition">
                      <FaCube className="text-orange-500 text-lg md:text-xl mb-1" />
                      360°
                    </button>
                    <button className="flex flex-col items-center justify-center bg-orange-50 p-2 md:p-3 rounded-lg text-xs text-gray-700 hover:bg-orange-100 transition">
                      <FaRegEye className="text-orange-500 text-lg md:text-xl mb-1" />
                      Try On
                    </button>
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><span className="w-1 h-4 bg-orange-500 rounded-full"></span>Similar Products</h3>
                  <div className="flex gap-2 overflow-x-auto pb-2">
                    {similarProducts.map((prod) => (
                      <div key={prod.id} className="flex-shrink-0 w-28 md:w-32 bg-white border border-gray-200 rounded-lg p-2">
                        <img src={prod.image} alt={prod.name} className="w-full h-14 md:h-16 object-contain" />
                        <p className="text-[10px] md:text-xs font-medium mt-1 truncate">{prod.name}</p>
                        <div className="flex items-center text-[9px] md:text-[10px] mt-0.5">
                          <FaStar className="text-yellow-400 mr-0.5" size={8} /> {prod.rating}
                        </div>
                        <p className="text-orange-600 font-bold text-xs md:text-sm mt-0.5">₹{prod.price}</p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaTruck className="text-orange-500" size={16} /> Delivery</h3>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Pincode"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value.replace(/\D/g, '').slice(0,6))}
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-xs md:text-sm focus:ring-1 focus:ring-orange-200 outline-none"
                    />
                    <button
                      onClick={checkDelivery}
                      className="bg-orange-500 text-white px-4 py-2 rounded-lg text-xs md:text-sm font-medium hover:bg-orange-600 transition"
                    >
                      Check
                    </button>
                  </div>
                  {deliveryChecked && (
                    <p className="text-green-600 text-[10px] md:text-xs mt-1.5 flex items-center gap-1"><FaCheckCircle size={10} /> Express delivery available</p>
                  )}
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2">Frame Color</h3>
                  <div className="flex gap-2">
                    {selectedProduct.colors?.map((color, idx) => (
                      <button
                        key={idx}
                        onClick={() => setSelectedColor(color)}
                        className={`w-7 h-7 md:w-8 md:h-8 rounded-full border-2 transition-all ${selectedColor === color ? 'border-orange-500 scale-110' : 'border-gray-300'}`}
                        style={{ backgroundColor: color.toLowerCase() }}
                      />
                    ))}
                  </div>
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mt-4 mb-2">Frame Size</h3>
                  <div className="flex gap-1.5">
                    {selectedProduct.sizes?.map((size) => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`px-3 py-1.5 md:px-4 md:py-2 rounded-lg border text-xs md:text-sm font-medium transition ${
                          selectedSize === size ? 'bg-orange-500 text-white border-orange-500' : 'bg-white border-gray-300 text-gray-700'
                        }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaCheckCircle className="text-orange-500" size={16} /> Highlights</h3>
                  <div className="grid grid-cols-2 gap-2">
                    {selectedProduct.highlights?.map((hl, idx) => (
                      <div key={idx} className="flex items-center gap-1.5 bg-orange-50 p-2 rounded-lg">
                        <FaCheckCircle className="text-orange-500 text-xs flex-shrink-0" />
                        <span className="text-[10px] md:text-xs text-gray-700">{hl}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaRupeeSign className="text-orange-500" size={16} /> EMI & Warranty</h3>
                  <div className="flex items-center gap-2 text-xs md:text-sm text-gray-700">
                    <FaShieldAlt className="text-green-500" size={14} />
                    <span>{warranty}</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs md:text-sm text-gray-700 mt-1">
                    <FaExchangeAlt className="text-blue-500" size={14} />
                    <span>7-day replacement</span>
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2">Reviews</h3>
                  <div className="flex items-center gap-3">
                    <div className="text-center">
                      <span className="text-3xl md:text-4xl font-bold text-gray-900">{selectedProduct.rating}</span>
                      <div className="flex text-yellow-400 mt-0.5">
                        {[...Array(5)].map((_, i) => (
                          i < Math.floor(selectedProduct.rating) ? <FaStar key={i} size={12} /> :
                          i < selectedProduct.rating ? <FaStarHalfAlt key={i} size={12} /> : <FaStar key={i} className="text-gray-300" size={12} />
                        ))}
                      </div>
                      <span className="text-[9px] md:text-xs text-gray-500">{selectedProduct.reviews} reviews</span>
                    </div>
                    <div className="flex-1 space-y-0.5">
                      {[5,4,3,2,1].map((star) => (
                        <div key={star} className="flex items-center gap-1 text-[9px] md:text-xs">
                          <span>{star}</span>
                          <FaStar className="text-yellow-400" size={8} />
                          <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                            <div className="h-full bg-orange-500" style={{ width: `${reviewStats[star]}%` }}></div>
                          </div>
                          <span className="text-gray-500 w-4 text-right">{reviewStats[star]}%</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4">
                    <p className="text-xs md:text-sm font-medium mb-2 flex items-center gap-1"><FaCamera className="text-orange-500" size={12} /> User Photos ⸱ 10</p>
                    <div className="flex gap-1 overflow-x-auto pb-1">
                      {[...Array(8)].map((_, i) => (
                        <div key={i} className="w-12 h-12 md:w-14 md:h-14 bg-gray-200 rounded-lg flex-shrink-0 flex items-center justify-center text-gray-400">
                          <FaCamera size={14} />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4 space-y-3">
                    {(showFullReviews ? userReviews : userReviews.slice(0,2)).map((rev, idx) => (
                      <div key={idx} className="border-b border-gray-100 pb-2 last:border-0">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-1.5">
                            <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center text-orange-600"><FaUser size={10} /></div>
                            <span className="font-medium text-xs md:text-sm">{rev.name}</span>
                          </div>
                          <span className="text-[9px] md:text-xs text-gray-400">{rev.date}</span>
                        </div>
                        <div className="flex text-yellow-400 text-[9px] md:text-xs mt-0.5">
                          {[...Array(5)].map((_, i) => <FaStar key={i} className={i < rev.rating ? 'text-yellow-400' : 'text-gray-300'} size={10} />)}
                        </div>
                        <p className="text-[10px] md:text-xs mt-0.5">{rev.comment}</p>
                      </div>
                    ))}
                    {userReviews.length > 2 && (
                      <button
                        onClick={() => setShowFullReviews(!showFullReviews)}
                        className="text-orange-500 text-[10px] md:text-xs font-medium mt-1 w-full text-center py-2 border border-orange-200 rounded-lg hover:bg-orange-50 transition"
                      >
                        {showFullReviews ? 'Show less' : 'Read All Reviews'}
                      </button>
                    )}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-2 flex items-center gap-1"><FaQuestionCircle className="text-orange-500" size={16} /> FAQs</h3>
                  <div className="space-y-1.5">
                    {faqs.map((faq, idx) => (
                      <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden">
                        <button
                          onClick={() => setExpandedFaq(expandedFaq === idx ? null : idx)}
                          className="w-full flex justify-between items-center p-2 md:p-3 text-left bg-gray-50 hover:bg-gray-100 transition"
                        >
                          <span className="text-xs md:text-sm font-medium">{faq.q}</span>
                          {expandedFaq === idx ? <FaChevronUp className="text-orange-500" size={12} /> : <FaChevronDown className="text-gray-400" size={12} />}
                        </button>
                        {expandedFaq === idx && (
                          <div className="p-2 md:p-3 text-[10px] md:text-xs text-gray-600 border-t border-gray-200 bg-white">
                            {faq.a}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-1">Product Details</h3>
                  <p className="text-[10px] md:text-xs text-gray-600 mb-2">{selectedProduct.description}</p>
                  <table className="w-full text-[10px] md:text-xs">
                    <tbody>
                      <tr><td className="py-1 text-gray-500">Material</td><td className="font-medium text-right">{selectedProduct.material}</td></tr>
                      <tr><td className="py-1 text-gray-500">Weight</td><td className="font-medium text-right">{selectedProduct.weight}</td></tr>
                      <tr><td className="py-1 text-gray-500">Collection</td><td className="font-medium text-right">{selectedProduct.collection}</td></tr>
                      <tr><td className="py-1 text-gray-500">Origin</td><td className="font-medium text-right">India</td></tr>
                    </tbody>
                  </table>
                </div>
                <div className="py-3 border-b border-gray-100 md:py-4">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-1">Shop by Looks</h3>
                  <div className="flex flex-wrap gap-1">
                    {['Chic & Glam', 'Comfy & Classy', 'Make Impact', 'Street Style'].map((look, i) => (
                      <span key={i} className="bg-orange-50 px-2 py-1 rounded-full text-[9px] md:text-xs text-orange-700 font-medium">#{look.toLowerCase().replace(/ /g,'')}</span>
                    ))}
                  </div>
                </div>
                <div className="py-3">
                  <h3 className="font-semibold text-gray-800 text-sm md:text-base mb-1">Recently Viewed</h3>
                  <div className="flex gap-2 overflow-x-auto pb-1">
                    {products.slice(0,3).map((prod) => (
                      <div key={prod.id} className="flex-shrink-0 w-20 md:w-24 text-center">
                        <img src={prod.image} alt={prod.name} className="w-full h-12 md:h-14 object-contain border border-gray-200 rounded-lg p-1" />
                        <p className="text-[9px] md:text-xs mt-0.5 truncate">{prod.name}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sticky bottom-0 bg-white/80 backdrop-blur-md border-t border-gray-200 p-3 md:hidden">
            <div className="flex justify-between items-center gap-2 max-w-xs mx-auto">
              <button className="bg-orange-500 text-white px-6 py-2 rounded-lg font-semibold text-xs flex items-center justify-center gap-1 hover:bg-orange-600 transition">
                <FaShoppingCart size={12} /> ADD
              </button>
              <button className="bg-black text-white px-6 py-2 rounded-lg font-semibold text-xs flex items-center justify-center gap-1 hover:bg-gray-900 transition border border-orange-500">
                <FaCreditCard size={12} /> BUY
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default ProductListing;